export default __webpack_public_path__ + "static/media/logo.7fe2a83d.png";